/**
 * トップビジュアルの季節パーティクル
 * - data-season に応じて桜・火の粉・枯れ葉・雪を生成
 * - 読みやすさ優先で少なめに配置
 */
export const SEASON_PARTICLES = {
  selectors: {
    billboard: '.home-billboard',
  },

  particleCount: 14,

  init() {
    const billboard = document.querySelector(this.selectors.billboard)

    if (!billboard) {
      return
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }

    const season = billboard.getAttribute('data-season') || 'spring'
    const container = document.createElement('div')

    container.className = 'home-billboard__particles'
    container.setAttribute('aria-hidden', 'true')

    for (let i = 0; i < this.particleCount; i++) {
      const particle = document.createElement('span')
      const size = this.getSize(season)
      const duration = this.getDuration(season)
      const delay = Math.random() * duration
      const drift = (-40 + Math.random() * 80).toFixed(1)
      const rotate = Math.floor(Math.random() * 360)

      particle.className = `home-billboard__particle home-billboard__particle--${season}`
      particle.style.setProperty('--x', `${(Math.random() * 100).toFixed(2)}%`)
      particle.style.setProperty('--size', `${size}`)
      particle.style.setProperty('--duration', `${duration.toFixed(2)}s`)
      particle.style.setProperty('--delay', `${delay.toFixed(2)}s`)
      particle.style.setProperty('--drift', `${drift}px`)
      particle.style.setProperty('--rotate', `${rotate}deg`)

      container.appendChild(particle)
    }

    billboard.prepend(container)
  },

  getSize(season) {
    switch (season) {
      case 'summer':
        return (0.35 + Math.random() * 0.45).toFixed(2)
      case 'winter':
        return (0.3 + Math.random() * 0.7).toFixed(2)
      case 'autumn':
        return (0.7 + Math.random() * 0.6).toFixed(2)
      default:
        return (0.55 + Math.random() * 0.55).toFixed(2)
    }
  },

  getDuration(season) {
    switch (season) {
      case 'summer':
        return 5 + Math.random() * 4
      case 'winter':
        return 8 + Math.random() * 6
      case 'autumn':
        return 7 + Math.random() * 5
      default:
        return 7 + Math.random() * 5
    }
  },
}
